import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import Swal from 'sweetalert2';
import { DashboardDataServiceService } from 'src/app/services/dashboard-data-service.service';
import { MatTabChangeEvent } from '@angular/material/tabs';

@Component({
  selector: 'app-payment-arrangement',
  templateUrl: './payment-arrangement.component.html',
  styleUrls: ['./payment-arrangement.component.scss']
})
export class PaymentArrangementComponent implements OnInit {
  form: FormGroup
  data: any = [];
  dataSource: any = new MatTableDataSource(this.data);
  displayedColumns: string[] = [
    "FNO",
    "Application",
    "Customer",
    "Name",
    "Contact",
    "Address",
    "ApplicationStatus"
  ];
  showtable = false;
  constructor(
    private formBuilder: FormBuilder,
    private dashboarddataservice: DashboardDataServiceService,
  ) { }
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator
  ngOnInit(): void {
    this.form = this.formBuilder.group({
      searchQuery: [null, Validators.required],
    })
  }
  search(content) {
    if (this.form.valid) {
      if (content == 'arrangement') {
        let value = this.form.value.searchQuery;
        this.dashboarddataservice.getApplicationsForPaymentArranges(value).subscribe((result) => {
          this.showtable = true;

          this.data = result;
          this.dataSource = new MatTableDataSource(this.data)
          this.dataSource.paginator = this.paginator;
        })
      }

      else {
        let value = this.form.value.searchQuery;
        this.dashboarddataservice.getApplicationsForrevokePaymentArranges(value).subscribe((result) => {
          this.showtable = true;

          this.data = result;
          this.dataSource = new MatTableDataSource(this.data)
          this.dataSource.paginator = this.paginator;
        })
      }
    }
  }
  onTabChange(event:MatTabChangeEvent){
    this.clearFilter()
  }
  save(content) {
    if (content == 'arangement') {
      const txt = 'Are you sure, Do you want to move the customer to payment arrangement status?'
      const Yes = 'Yes';
      const No = 'No';
      Swal.fire({
        title: 'Confirmation',
        text: txt,
        icon: 'info',
        showCancelButton: true,
        confirmButtonColor: '#7D32DE',
        cancelButtonColor: '#23C00A',
        confirmButtonText: Yes,
        cancelButtonText: No,
      }).then((result) => {
        if (result.value) {
          let postData: any = {
            search: this.form.value.searchQuery,
          }
          this.dashboarddataservice.submitPaymentArrangement(postData).subscribe((result) => {
            if (result) {
              Swal.fire('Success!!', 'Payment arrangement was done successfully', 'success')
              this.clearFilter()
            }
          })
        }
      });
    }
    else {
      const txt = 'Are you sure, Do you want to revoke the customer from payment arrangement status?'
      const Yes = 'Yes';
      const No = 'No';
      Swal.fire({
        title: 'Confirmation',
        text: txt,
        icon: 'info',
        showCancelButton: true,
        confirmButtonColor: '#7D32DE',
        cancelButtonColor: '#23C00A',
        confirmButtonText: Yes,
        cancelButtonText: No,
      }).then((result) => {
        if (result.value) {
          let postData: any = {
            search: this.form.value.searchQuery,
          }
          this.dashboarddataservice.revokePaymentArrangement(postData).subscribe((result) => {
            if (result) {
              Swal.fire('Success!!', 'Payment arrangement Revoked successfully', 'success')
              this.clearFilter()
            }
          })
        }
      });
    }
  }
  clearFilter() {
    this.dataSource= new MatTableDataSource(null)
    this.showtable=false;
    this.form.reset()
  }

}
